"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.interactiveChipPropTypes = void 0;

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _badge = require("../../badge");

var interactiveChipPropTypes = {
  badge: _stencilReactDesc.PropTypes.shape({
    type: _stencilReactDesc.PropTypes.oneOf(Object.values(_badge.BadgeType)),
    value: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.number, _stencilReactDesc.PropTypes.string]).isRequired
  }).description('Badge to show next to the text. Only available for interactive chips.'),
  isSelected: _stencilReactDesc.PropTypes.bool.description('Determines whether the chip is currently selected by showing a visual indication.'),
  onClick: _stencilReactDesc.PropTypes.func.description('Makes the chip to be clickable. This function will then be called when the user clicks the chip.').format('(event: React.MouseEvent) => void')
};
exports.interactiveChipPropTypes = interactiveChipPropTypes;